import React from 'react';

//component
import WmsButton from './../../../components/WmsButton/WmsButton.jsx';
import WmsDropdown from './../../../components/WmsDropdown/WmsDropdown.jsx';
import WmsCheckBox from './../../../components/WmsCheckBox/WmsCheckBox.jsx';
import WmsRadio from './../../../components/WmsRadio/WmsRadio.tsx';
import WmsContainer from './../../../components/WmsContainer/WmsContainer.jsx';
import WmsCollapse from './../../../components/WmsCollapse/WmsCollapse.jsx';
import VirtualGridComponent from './../../../components_proto/VirtualGridComponent/VirtualGridComponent.jsx';
import WmsModel from './../../../components/WmsModel/WmsModel.jsx';
import { AddEditColumnModel } from './../../../components/AddEditColumn/add-edit-columns.component.jsx';

import * as findOrdersService from '../findOrders.services.jsx';
import * as GlobalService from './../../../global_services';
import * as smallParcelSettingsServices from '../../../smallParcelSettings/small-parcel-settings.services.jsx';
import * as smallParcelService from '../../../smallParcel/smallParcel.service.jsx';
import * as papiDocumentUtil from '../../../smallParcel/papi-document.util.js';
import {
    areAllPackagesSelected,
    findFirstPackageMatchIndex,
    packageRowIsInLoadedRange,
    packageSearchFieldName,
    packageWrapperScrollTop,
    readPackageField,
    renderHighlightedPackageText,
} from './ucc128-package-search.js';
import {
    formatPackageDimensions,
    formatPackageWeight,
    resolvePackageTypeName,
    normalizeUcc128GridConfig,
    packageWeightLabel,
    UCC128_PACKAGE_GRID_META_NAME,
} from './ucc128-package-display.js';
import './ucc128-package-label-model.scss';

export class Ucc128PackageLabelModel extends React.Component {

    constructor(props) {

        super(props);

        this.translate = window.translate;
        this.modalId = "#" + this.props.windowId + "shipUcc128PackageLabelModel";
        this.state = {
            selector: "order",
            gifUcc128PackageLabel: false,
            optionsPackingReports: [],
            optionsOutputTypes: [],
            indexOptionsPackingReports: 0,
            indexSelectedFormat: "zpl",
            ucc128TemplatesRaw: [],
            packageSelection: "all",
            optionsPackageUcc128: [],
            selectedPackageIds: [],
            packageSearchText: "",
            packageSearchField: "ucc128",
            packReferenceNum: null,
            packPoNum: null,
            ucc128GridConfig: "",
            ucc128GridConfigReady: false,
            isOpenPackageColumnChooser: false,
        }
        this.packageGridId = this.props.windowId + "ucc128PackageGrid";
        this.packageGridAllColumns = [
            {
                field: "packageId",
                title: this.translate('Label_Ucc128_Package_Id'),
                width: 115,
                wmsid: 1,
                template: (dataItem) => this.renderPackageSearchCell(dataItem, "packageId"),
            },
            {
                field: "ucc128",
                title: this.translate('Label_Ucc128_Barcode'),
                width: 190,
                wmsid: 2,
                template: (dataItem) => this.renderPackageSearchCell(dataItem, "ucc128"),
            },
            {
                field: "packageType",
                title: this.translate('Label_Name'),
                width: 145,
                wmsid: 3,
            },
            {
                field: "dimensions",
                title: this.translate('Label_Ucc128_Dimensions'),
                width: 140,
                wmsid: 4,
            },
            {
                field: "weight",
                title: this.translate('Label_Weight'),
                width: 100,
                wmsid: 5,
            },
        ];
        this.packageGridColumns = this.packageGridAllColumns.filter((column) => {
            return column.field === "packageId" || column.field === "ucc128" || column.field === "packageType";
        });
        this.packageGridSchema = {
            model: {
                id: "packageId",
                fields: {
                    packageId: { type: "string" },
                    ucc128: { type: "string" },
                    packageType: { type: "string" },
                    dimensions: { type: "string" },
                    weight: { type: "string" },
                },
            },
        };
    }

    getSelectedOrders = () => {
        if (Array.isArray(this.props.sharedSelectedOrders) && this.props.sharedSelectedOrders.length) {
            return this.props.sharedSelectedOrders;
        }
        return this.props.sharedSelectedOrderData ? [this.props.sharedSelectedOrderData] : [];
    }

    getSelectedOrderIds = () => {
        const fromProps = this.props.sharedSelectedOrderIds || [];
        if (fromProps.length) {
            return fromProps;
        }
        return this.getSelectedOrders().map((order) => order.OrderId).filter((orderId) => orderId != null);
    }

    readPackText = (source, key) => {
        if (!source || source[key] == null) {
            return "";
        }
        return String(source[key]).trim();
    }

    readPackOrderFields = (response) => {
        const records = Array.isArray(response) ? response : (response ? [response] : []);
        let referenceNum = "";
        let poNum = "";
        records.forEach((item) => {
            if (!referenceNum) {
                referenceNum = this.readPackText(item, "ReferenceNum");
            }
            if (!poNum) {
                poNum = this.readPackText(item, "PoNum");
            }
            const packages = item && Array.isArray(item.PackageData) ? item.PackageData : [];
            packages.forEach((pkg) => {
                if (!referenceNum) {
                    referenceNum = this.readPackText(pkg, "ReferenceNum");
                }
                if (!poNum) {
                    poNum = this.readPackText(pkg, "PoNum");
                }
            });
        });
        return { referenceNum: referenceNum, poNum: poNum };
    }

    getSharedOrderValue = (read) => {
        const orders = this.getSelectedOrders();
        if (!orders.length) {
            return "";
        }
        const values = orders.map((order) => {
            const value = read(order);
            return value == null ? "" : String(value).trim();
        });
        const first = values[0];
        if (values.every((value) => value === first)) {
            return first;
        }
        return this.translate("Label_Ucc128_Multiple");
    }

    isMultipleOrderSelection = () => {
        return this.getSelectedOrders().length > 1;
    }

    getSharedOrderDisplay = (read) => {
        const orders = this.getSelectedOrders();
        if (!orders.length) {
            return { text: "", multiple: false };
        }
        const values = orders.map((order) => {
            const value = read(order);
            return value == null ? "" : String(value).trim();
        });
        const first = values[0];
        if (values.every((value) => value === first)) {
            return { text: first, multiple: false };
        }
        return {
            text: this.translate("Label_Ucc128_Multiple_Parenthetical"),
            multiple: true,
        };
    }

    getPackageCount = () => {
        return this.getSelectedOrders().reduce((sum, order) => {
            return sum + (Number(order.TotPackages) || 0);
        }, 0);
    }

    collectPackageData = (response) => {
        if (!response) {
            return [];
        }
        if (Array.isArray(response)) {
            return response.reduce((packages, item) => {
                if (item && Array.isArray(item.PackageData)) {
                    return packages.concat(item.PackageData);
                }
                if (item && item.PackageId != null) {
                    packages.push(item);
                }
                return packages;
            }, []);
        }
        return response.PackageData || [];
    }

    loadPackageColumnLayout = () => {
        GlobalService.getUserClientMetaData(UCC128_PACKAGE_GRID_META_NAME).then((data) => {
            if (!this._isMounted) {
                return;
            }
            this.setState({
                ucc128GridConfig: normalizeUcc128GridConfig(data),
                ucc128GridConfigReady: true,
            });
        }).catch(() => {
            if (!this._isMounted) {
                return;
            }
            this.setState({ ucc128GridConfigReady: true });
        });
    }

    savePackageColumnLayout = () => {
        const grid = this.getPackageGrid();
        if (!grid) {
            return;
        }
        const currentByField = {};
        (grid.columns || []).forEach((column) => {
            if (column && column.field) {
                currentByField[column.field] = column;
            }
        });
        const columns = this.packageGridAllColumns
            .filter((column) => currentByField[column.field])
            .map((column) => Object.assign({}, column, {
                width: currentByField[column.field].width || column.width,
            }));
        // setOptions rebuilds the grid and drops the row-click listener.
        // VirtualGridComponent attaches that listener only while
        // dataBindingInitial is 0, which is no longer true after the first paint.
        this.markPackageGridForSelectionRebind();
        grid.setOptions({ columns: columns });
        this.rebindPackageGridSelection();
        this.fitPackageGridToModal();
        const submission = GlobalService.prepareGridOptionsForStorage(
            grid.columns,
            grid.dataSource.sort() || [],
            grid.dataSource.filter()
        );
        const config = normalizeUcc128GridConfig(submission && submission.optionsData);
        this.setState({ ucc128GridConfig: config });
        if (config) {
            GlobalService.setUserClientMetaData(UCC128_PACKAGE_GRID_META_NAME, config);
        }
    }

    openPackageColumnChooser = () => {
        this.setState({ isOpenPackageColumnChooser: true });
    }

    closePackageColumnChooser = () => {
        this.setState({ isOpenPackageColumnChooser: false });
    }

    updatePackageGridData = () => {
        const grid = this.getPackageGrid();
        if (grid && grid.dataSource) {
            grid.dataSource.read();
        }
    }

    packageWeightLabel = () => {
        const order = this.props.sharedSelectedOrderData || this.getSelectedOrders()[0];
        const facilityId = order && (order.FacilityId != null ? order.FacilityId : order.facilityId);
        return packageWeightLabel(GlobalService.getMeasurementStandardFlag(facilityId));
    }

    loadPackageUcc128Options = () => {
        const orderIds = this.getSelectedOrderIds();
        if (orderIds.length !== 1) {
            return Promise.resolve();
        }
        return smallParcelService.getOrderPackInfo(orderIds[0]).catch(() => null).then((response) => {
            const seen = {};
            const options = [];
            const weightLabel = this.packageWeightLabel();
            this.collectPackageData(response).forEach((pkg) => {
                if (!pkg || pkg.Ucc128 == null || pkg.PackageId == null) {
                    return;
                }
                const ucc128 = String(pkg.Ucc128).trim();
                const packageId = String(pkg.PackageId);
                if (!ucc128 || ucc128 === "0" || seen[packageId]) {
                    return;
                }
                seen[packageId] = true;
                options.push({
                    packageId: packageId,
                    ucc128: ucc128,
                    packageType: resolvePackageTypeName(pkg, this.translate("Label_Custom_Dimensions")),
                    dimensions: formatPackageDimensions(pkg),
                    weight: formatPackageWeight(pkg.Weight, weightLabel),
                });
            });
            if (this._isMounted) {
                const packFields = this.readPackOrderFields(response);
                this.setState({
                    optionsPackageUcc128: options,
                    packReferenceNum: packFields.referenceNum,
                    packPoNum: packFields.poNum,
                });
            }
        });
    }
    componentDidMount() {
        this._isMounted = true;
        setTimeout(() => this.syncUcc128CompactWindow(), 150);
        this.loadPackageColumnLayout();

        kendo.ui.progress($(this.modalId), true);
        const customerId = this.props.sharedSelectedOrderData
            && this.props.sharedSelectedOrderData.CustomerId;
        const schemaPromise = smallParcelSettingsServices.getCarrierAccountSchema();
        const settingsPromise = customerId
            ? smallParcelService.getCustomersSettings([customerId]).catch(() => null)
            : Promise.resolve(null);
        // Held in the same wait as the templates: a scan landing before the
        // package list arrives would otherwise be reported as no match.
        const packagesPromise = this.isMultipleOrderSelection()
            ? Promise.resolve()
            : this.loadPackageUcc128Options();

        Promise.all([schemaPromise, settingsPromise, packagesPromise]).then(([schemaResponse, settingsResponse]) => {
            if (!this._isMounted) {
                return;
            }
            if (schemaResponse && schemaResponse.status == 200) {
                const documentTemplates = papiDocumentUtil.parseDocumentTemplatesFromSchemaResponse(
                    schemaResponse.data
                );
                const filtered = papiDocumentUtil.filterPapiDocumentTemplates(
                    documentTemplates,
                    papiDocumentUtil.PAPI_UCC128_DOC_TYPE,
                    false,
                    customerId
                );
                const options = papiDocumentUtil.mapPapiTemplatesToDropdownOptions(filtered, false);

                let packaging = null;
                if (settingsResponse && settingsResponse.data && settingsResponse.data.length > 0) {
                    packaging = settingsResponse.data[0].Options
                        && settingsResponse.data[0].Options.Packaging;
                }
                const savedDefaultId = papiDocumentUtil.readCustomerPapiTemplateSetting(
                    packaging,
                    "ucc128"
                ).templateId;
                const savedValue = savedDefaultId
                    ? papiDocumentUtil.makeDocOptionValue(papiDocumentUtil.DOC_ENGINE_PAPI, savedDefaultId)
                    : null;
                const selection = papiDocumentUtil.resolveTemplateSelection(
                    options,
                    savedValue,
                    !savedValue
                );
                const formatOptions = papiDocumentUtil.getFormatOptionsForTemplate(
                    selection.value,
                    filtered,
                    papiDocumentUtil.PAPI_DOC_TYPES.ucc128
                );
                let savedFormat = papiDocumentUtil.resolvePapiDocumentFormat(packaging, "ucc128");
                if (!formatOptions.some(function (opt) { return opt.Value === savedFormat; })) {
                    savedFormat = formatOptions.length ? formatOptions[0].Value : "zpl";
                }
                this.setState({
                    optionsPackingReports: options,
                    ucc128TemplatesRaw: filtered,
                    optionsOutputTypes: formatOptions,
                    indexSelectedFormat: savedFormat,
                    indexOptionsPackingReports: selection.templateId,
                });
            }
        }).finally(() => {
            kendo.ui.progress($(this.modalId), false);
        });
    }

    // Remember the opened "All packages" window height, then re-apply it after Selected packages expands the dialog.
    syncUcc128CompactWindow = () => {
        if (!this._isMounted || typeof $ !== "function" || this.isMultipleOrderSelection()
            || this.state.packageSelection !== "all") {
            return;
        }
        const modalElementId = this.props.windowId + "shipUcc128PackageLabelModel";
        const modelObj = $("#" + modalElementId).data("kendoWindow");
        if (!modelObj || !modelObj.wrapper || !modelObj.wrapper.length) {
            return;
        }
        const wrapperHeight = Math.round(modelObj.wrapper.height() || 0);
        if (!this._ucc128CompactWrapperHeight && wrapperHeight > 0) {
            this._ucc128CompactWrapperHeight = wrapperHeight;
            return;
        }
        if (!this._ucc128CompactWrapperHeight) {
            return;
        }
        const height = this._ucc128CompactWrapperHeight;
        modelObj.wrapper.css("height", height + "px");
        const titleHeight = modelObj.wrapper.children(".k-window-titlebar").outerHeight() || 0;
        modelObj.element.css({
            height: Math.max(height - titleHeight, 0) + "px",
            width: "100%",
        });
    }

    componentDidUpdate(prevProps, prevState) {
        this.fitPackageGridToModal();
        if (prevState.packageSelection === "selected" && this.state.packageSelection === "all") {
            requestAnimationFrame(() => this.syncUcc128CompactWindow());
        }
        if (prevState.packageSelection !== "selected" && this.state.packageSelection === "selected") {
            requestAnimationFrame(() => this.focusPackageSearchInput());
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (typeof $ === "function") {
            $("#" + this.props.windowId + "ucc128SelectPackages").off("click.ucc128SearchFocus");
        }
        if (this._packageGridFitFrame) {
            cancelAnimationFrame(this._packageGridFitFrame);
        }
        this.clearPackageSearchTimers();
        this.setSearchFieldRef(null);
        this.setSearchInputRef(null);
    }

    focusPackageSearchInput = () => {
        if (this._isMounted && this.state.packageSelection === "selected" && this.searchInputElement) {
            this.searchInputElement.focus();
        }
    }

    fitPackageGridToModal = () => {
        if (this._packageGridFitFrame) {
            cancelAnimationFrame(this._packageGridFitFrame);
        }
        this._packageGridFitFrame = requestAnimationFrame(() => {
            this.applyPackageGridHeight();
        });
    }

    applyPackageGridHeight = () => {
        this._packageGridFitFrame = null;
        if (!this._isMounted || this.isMultipleOrderSelection() || this.state.packageSelection !== "selected") {
            return;
        }
        const gridEl = document.getElementById(this.packageGridId);
        if (!gridEl) {
            return;
        }
        const grid = $(gridEl).data("kendoGrid");
        const area = gridEl.closest(".wms-grid-area-wrapper");
        if (!grid || !area) {
            return;
        }
        const maxGridHeight = 325;
        area.style.height = maxGridHeight + "px";
        area.style.minHeight = maxGridHeight + "px";
        area.style.maxHeight = maxGridHeight + "px";
        const currentHeight = Math.round(grid.element.outerHeight() || 0);
        if (currentHeight !== maxGridHeight) {
            grid.element.height(maxGridHeight);
            grid.resize();
        }
    }

    bindElement = (current, next, eventName, handler) => {
        if (current === next) {
            return current;
        }
        if (current) {
            current.removeEventListener(eventName, handler);
        }
        if (next) {
            next.addEventListener(eventName, handler);
        }
        return next;
    }

    setSearchFieldRef = (element) => {
        this.searchFieldElement = this.bindElement(
            this.searchFieldElement,
            element,
            "change",
            this.onPackageSearchFieldChange
        );
    }

    setSearchInputRef = (element) => {
        this.searchInputElement = this.bindElement(
            this.searchInputElement,
            element,
            "input",
            this.onPackageSearchInput
        );
        if (element && typeof $ === "function") {
            $("#" + this.props.windowId + "ucc128SelectPackages")
                .off("click.ucc128SearchFocus")
                .on("click.ucc128SearchFocus", () => this.focusPackageSearchInput());
        }
        if (element && this.state.packageSelection === "selected") {
            requestAnimationFrame(() => element.focus());
        }
    }

    getPackageGridHelper = () => {
        return this.packageWmsGrid && this.packageWmsGrid.state && this.packageWmsGrid.state.KendoGrid;
    }

    getPackageGrid = () => {
        if (typeof $ !== "function") {
            return null;
        }
        const grid = $("#" + this.packageGridId).data("kendoGrid");
        return grid || null;
    }

    markPackageGridForSelectionRebind = () => {
        const holder = this.packageWmsGrid;
        if (!holder || !holder.state) {
            return;
        }
        holder.state.dataBindingInitial = 0;
        holder.state.intialiseKeyDown = 0;
    }

    rebindPackageGridSelection = () => {
        const holder = this.packageWmsGrid;
        if (!holder || typeof holder.gridClickEventHandler !== "function") {
            return;
        }
        holder.gridClickEventHandler();
    }

    renderPackageSearchCell = (dataItem, field) => {
        const activeField = packageSearchFieldName(this.state.packageSearchField);
        const query = field === activeField ? this.state.packageSearchText : "";
        return renderHighlightedPackageText(readPackageField(dataItem, field), query);
    }

    packageSearchColumnIndex = (grid, field) => {
        if (!grid || !grid.thead) {
            return -1;
        }
        let columnIndex = -1;
        const headerRow = grid.thead.find("tr").first().children("th");
        headerRow.each((index, header) => {
            if (header.getAttribute("data-field") === field) {
                columnIndex = index;
            }
        });
        return columnIndex;
    }

    paintPackageSearchHighlights = () => {
        const grid = this.getPackageGrid();
        if (!grid || !grid.tbody) {
            return;
        }
        const activeField = packageSearchFieldName(this.state.packageSearchField);
        const query = this.state.packageSearchText;
        ["packageId", "ucc128"].forEach((field) => {
            const columnIndex = this.packageSearchColumnIndex(grid, field);
            if (columnIndex < 0) {
                return;
            }
            const cellQuery = field === activeField ? query : "";
            grid.tbody.children("tr").each((_, row) => {
                const cell = row.children[columnIndex];
                if (!cell) {
                    return;
                }
                const html = renderHighlightedPackageText(
                    readPackageField(grid.dataItem(row), field),
                    cellQuery
                );
                if (cell.innerHTML !== html) {
                    cell.innerHTML = html;
                }
            });
        });
    }

    getPackageRecordsInDisplayOrder = () => {
        const fallback = this.state.optionsPackageUcc128 || [];
        const grid = this.getPackageGrid();
        if (!grid || !grid.dataSource) {
            return fallback;
        }
        const sort = grid.dataSource.sort();
        if (typeof kendo !== "undefined" && kendo.data && kendo.data.Query && sort && sort.length) {
            const loaded = grid.dataSource.data();
            const source = loaded && loaded.length >= fallback.length ? loaded : fallback;
            return new kendo.data.Query(source).sort(sort).data;
        }
        return fallback;
    }

    measurePackageRowHeight = (grid) => {
        const virtual = grid.virtualScrollable;
        if (virtual && typeof virtual.itemHeight === "number" && virtual.itemHeight > 0) {
            return virtual.itemHeight;
        }
        const row = grid.tbody && grid.tbody.children("tr").first();
        if (row && row.length) {
            const height = row.outerHeight();
            if (height) {
                return height;
            }
        }
        return 0;
    }

    getPackageGridScrollbar = (grid) => {
        const virtual = grid.virtualScrollable;
        if (virtual && virtual.verticalScrollbar && virtual.verticalScrollbar.length) {
            return virtual.verticalScrollbar;
        }
        if (grid.wrapper) {
            const bar = grid.wrapper.find(".k-scrollbar");
            if (bar.length) {
                return bar;
            }
        }
        return grid.content || null;
    }

    clearPackageSearchTimers = () => {
        if (this._packageSearchFrame) {
            cancelAnimationFrame(this._packageSearchFrame);
            this._packageSearchFrame = null;
        }
        (this._packageSearchTimers || []).forEach((timer) => clearTimeout(timer));
        this._packageSearchTimers = [];
    }

    readPackageScrollPosition = (grid) => {
        if (!grid || !grid.virtualScrollable) {
            return null;
        }
        const virtual = grid.virtualScrollable;
        const bar = virtual.verticalScrollbar;
        const wrap = virtual.wrapper;
        return {
            bar: bar && bar.length && bar[0] ? bar[0].scrollTop : 0,
            wrap: wrap && wrap.length && wrap[0] ? wrap[0].scrollTop : 0,
        };
    }

    restorePackageScrollPosition = (grid, position) => {
        if (!grid || !position || !grid.virtualScrollable) {
            return;
        }
        const virtual = grid.virtualScrollable;
        const bar = virtual.verticalScrollbar;
        const wrap = virtual.wrapper;
        if (bar && bar.length && bar[0] && bar[0].scrollTop !== position.bar) {
            bar.scrollTop(position.bar);
        }
        if (wrap && wrap.length && wrap[0]) {
            wrap[0].scrollTop = position.wrap;
        }
    }

    rememberPackageScrollPosition = () => {
        this._packageScrollHold = this.readPackageScrollPosition(this.getPackageGrid());
    }

    packageLoadedRange = (grid) => {
        const virtual = grid.virtualScrollable;
        const dataSource = grid.dataSource;
        const rangeStart = virtual && virtual._rangeStart != null
            ? virtual._rangeStart
            : ((dataSource && dataSource.skip && dataSource.skip()) || 0);
        const pageSize = (dataSource && dataSource.take && dataSource.take()) || 40;
        return { rangeStart: rangeStart, pageSize: pageSize };
    }

    // Crossing a virtual page makes Kendo park the content one row down, which
    // hides the match. Put that row at the top of the loaded window instead.
    alignPackageScrollWrapper = (grid, index) => {
        const virtual = grid && grid.virtualScrollable;
        const wrap = virtual && virtual.wrapper;
        if (!wrap || !wrap.length || !wrap[0] || index < 0) {
            return;
        }
        const rowHeight = this.measurePackageRowHeight(grid);
        const range = this.packageLoadedRange(grid);
        if (!rowHeight || !packageRowIsInLoadedRange(index, range.rangeStart, range.pageSize)) {
            return;
        }
        wrap[0].scrollTop = packageWrapperScrollTop(index, range.rangeStart, rowHeight);
    }

    scrollPackageGridToIndex = (grid, index) => {
        const rowHeight = this.measurePackageRowHeight(grid);
        const scrollbar = this.getPackageGridScrollbar(grid);
        if (!rowHeight || !scrollbar || index < 0) {
            return;
        }
        const target = index * rowHeight;
        const current = scrollbar[0] ? scrollbar[0].scrollTop : scrollbar.scrollTop();
        if (current !== target) {
            scrollbar.scrollTop(target);
        }
        this.alignPackageScrollWrapper(grid, index);
    }

    schedulePackageScrollSettle = (generation, index, hold) => {
        const settle = () => {
            if (!this._isMounted || generation !== this._packageSearchGeneration) {
                return;
            }
            const grid = this.getPackageGrid();
            if (!grid) {
                return;
            }
            if (index >= 0) {
                this.alignPackageScrollWrapper(grid, index);
                return;
            }
            this.restorePackageScrollPosition(grid, hold);
        };
        settle();
        this._packageSearchTimers.push(setTimeout(settle, 0));
        this._packageSearchTimers.push(setTimeout(settle, 50));
    }

    applyPackageSearch = () => {
        const generation = (this._packageSearchGeneration || 0) + 1;
        this._packageSearchGeneration = generation;
        const hold = this._packageScrollHold;
        this.clearPackageSearchTimers();
        this._packageSearchGeneration = generation;
        this._packageSearchFrame = requestAnimationFrame(() => {
            this._packageSearchFrame = null;
            if (!this._isMounted || generation !== this._packageSearchGeneration) {
                return;
            }
            this.paintPackageSearchHighlights();
            const query = this.state.packageSearchText;
            const index = String(query || "").trim()
                ? findFirstPackageMatchIndex(
                    this.getPackageRecordsInDisplayOrder(),
                    this.state.packageSearchField,
                    query
                )
                : -1;
            this._pendingPackageScrollIndex = index;
            const grid = this.getPackageGrid();
            if (!grid) {
                return;
            }
            if (index < 0) {
                this.restorePackageScrollPosition(grid, hold);
                this.schedulePackageScrollSettle(generation, -1, hold);
                return;
            }
            this.scrollPackageGridToIndex(grid, index);
            this.schedulePackageScrollSettle(generation, index, hold);
        });
    }

    // Kendo rebuilds the grid table on every setOptions call, and VirtualGridComponent
    // calls setOptions itself (for example to swap the "no records" template), not
    // only when Manage Columns is saved. Each rebuild drops the row-click listener,
    // and with nothing selected Print stays disabled because no row can be picked.
    // So check on every dataBound: if the table is a new one, attach the listener again.
    ensurePackageGridSelectionBound = () => {
        const grid = this.getPackageGrid();
        const table = grid && grid.table && grid.table[0];
        if (!table) {
            return;
        }
        if (this._packageGridTable && this._packageGridTable !== table) {
            this.markPackageGridForSelectionRebind();
            this.rebindPackageGridSelection();
        }
        this._packageGridTable = table;
    }

    onPackageGridDataBound = () => {
        this.ensurePackageGridSelectionBound();
        this.applyPackageGridHeight();
        this.paintPackageSearchHighlights();
        const generation = this._packageSearchGeneration;
        const index = this._pendingPackageScrollIndex;
        if (index == null || index < 0) {
            return;
        }
        this._packageSearchTimers = this._packageSearchTimers || [];
        this._packageSearchTimers.push(setTimeout(() => {
            if (!this._isMounted || generation !== this._packageSearchGeneration) {
                return;
            }
            if (this._pendingPackageScrollIndex !== index) {
                return;
            }
            const grid = this.getPackageGrid();
            if (grid) {
                this.alignPackageScrollWrapper(grid, index);
            }
        }, 0));
    }

    syncSelectedPackageIds = (kendoGrid) => {
        const keys = (kendoGrid && kendoGrid.getKeys()) || [];
        this.setState({
            selectedPackageIds: keys.map((key) => String(key)),
        });
    }

    onPackageGridSelection = (kendoGrid) => {
        this.syncSelectedPackageIds(kendoGrid);
    }

    onPackageSearchFieldChange = (event) => {
        this.rememberPackageScrollPosition();
        this.setState({
            packageSearchField: event.target.value,
        }, this.applyPackageSearch);
    }

    onPackageSearchInput = (event) => {
        this.rememberPackageScrollPosition();
        this.setState({
            packageSearchText: event.target.value,
        }, this.applyPackageSearch);
    }

    onSelectAllChange = (event) => {
        const checked = event.target.checked;
        const helper = this.getPackageGridHelper();
        const packages = this.state.optionsPackageUcc128 || [];
        if (!helper) {
            return;
        }
        if (checked) {
            helper.addMassToSelection(packages);
        } else {
            packages.forEach((pkg) => {
                helper.addSelections(pkg.packageId, pkg, "remove");
            });
            helper.repaintSelections();
        }
        this.syncSelectedPackageIds(helper);
        if (this.packageWmsGrid && this.packageWmsGrid.updateGridSummary) {
            this.packageWmsGrid.updateGridSummary();
        }
    }

    getSelectedUcc128List = () => {
        const seen = {};
        const list = [];
        const selected = this.state.selectedPackageIds;
        this.state.optionsPackageUcc128.forEach((pkg) => {
            if (selected.indexOf(pkg.packageId) === -1 || !pkg.ucc128 || seen[pkg.ucc128]) {
                return;
            }
            seen[pkg.ucc128] = true;
            list.push(pkg.ucc128);
        });
        return list;
    }

    handleChangeEvent = (e) => {
        if (e.target.name !== "indexOptionsPackingReports") {
            this.setState({ [e.target.name]: e.target.value });
            return;
        }
        const selected = papiDocumentUtil.flattenPapiDropdownOptions(this.state.optionsPackingReports)
            .find(function (option) { return option && String(option.id) === String(e.target.value); });
        const formatOptions = papiDocumentUtil.getFormatOptionsForTemplate(
            selected && selected.value,
            this.state.ucc128TemplatesRaw,
            papiDocumentUtil.PAPI_DOC_TYPES.ucc128
        );
        const currentFormat = this.state.indexSelectedFormat;
        const nextFormat = formatOptions.some(function (opt) { return opt.Value === currentFormat; })
            ? currentFormat
            : (formatOptions.length ? formatOptions[0].Value : "zpl");
        this.setState({
            indexOptionsPackingReports: e.target.value,
            optionsOutputTypes: formatOptions,
            indexSelectedFormat: nextFormat,
        });
    }

    handleFormatChange = (e) => {
        this.setState({
            indexSelectedFormat: e.target.value,
        });
    }

    handlePackageSelectionChange = (e) => {
        this.setState({
            packageSelection: e.target.value,
        });
    }

    getGeneratedLabelCount = () => {
        if (this.state.packageSelection === "selected") {
            return this.state.selectedPackageIds.length;
        }
        if (this.state.optionsPackageUcc128.length > 0) {
            return this.state.optionsPackageUcc128.length;
        }
        return this.getPackageCount();
    }

    notifyUcc128LabelsGenerated = () => {
        const count = this.getGeneratedLabelCount();
        const messageKey = count === 1
            ? "Label_Ucc128_Label_Sent_To_Printer"
            : "Label_Ucc128_Labels_Sent_To_Printer";
        GlobalService.notificationNewDesign(
            "success",
            this.translate("Label_Ucc128_Package_Labels_Generated"),
            this.translate(messageKey).replace("{count}", count)
        );
    }

    notifyUcc128LabelsFailed = () => {
        GlobalService.notificationNewDesign(
            "error",
            this.translate("Label_Ucc128_Package_Labels_Generate_Failed"),
            this.translate("Label_Ucc128_Package_Labels_Try_Again")
        );
    }

    generatePapiUcc128PackageLabel = () => {
        this.setState({ gifUcc128PackageLabel: true });

        const templateId = this.state.indexOptionsPackingReports;
        const templateVersion = papiDocumentUtil.findPapiTemplateVersion(
            this.state.optionsPackingReports,
            templateId
        );

        const outputFormat = this.state.indexSelectedFormat || "pdf";

        const payload = {
            TransactionIds: this.props.sharedSelectedOrderIds,
            CustomerId: (this.props.sharedSelectedOrderData
                && this.props.sharedSelectedOrderData.CustomerId != null)
                ? this.props.sharedSelectedOrderData.CustomerId
                : null,
            PapiTemplateId: templateId,
            PapiTemplateVersion: templateVersion,
            OutputFormat: outputFormat,
            Ucc128List: !this.isMultipleOrderSelection() && this.state.packageSelection === "selected"
                ? this.getSelectedUcc128List()
                : [],
        };

        findOrdersService.PapiUcc128PackageLabelGenerator(payload).then((response) => {
            if (!(response && response.status === 200 && response.data)) {
                this.notifyUcc128LabelsFailed();
                return;
            }
            // Only a confirmed print (true) may say the labels were sent.
            // false = printer missing or the job failed (already reported).
            // null = not confirmed, including a Browser Print handoff and a PDF preview.
            const printOptions = { suppressSuccessNotification: true };
            const printed = outputFormat === "zpl"
                ? GlobalService.printDataInZplPrinter(
                    papiDocumentUtil.decodeZplResponseData(response.data), false, printOptions)
                : GlobalService.printOrViewPackingSlipPdf(response.data, printOptions);

            return Promise.resolve(printed).then((didPrint) => {
                if (didPrint === true) {
                    this.notifyUcc128LabelsGenerated();
                    this.props.onClose();
                    return;
                }
                if (didPrint == null && outputFormat !== "zpl") {
                    this.props.onClose();
                }
            });
        }).catch(() => {
            this.notifyUcc128LabelsFailed();
        }).finally(() => {
            if (this._isMounted) {
                this.setState({ gifUcc128PackageLabel: false });
                kendo.ui.progress($(this.modalId), false);
            }
        });
    }

    render() {
        const multipleOrders = this.isMultipleOrderSelection();
        const showPackagePicker = !multipleOrders && this.state.packageSelection === "selected";
        const packages = this.state.optionsPackageUcc128 || [];
        const allPackagesSelected = areAllPackagesSelected(packages, this.state.selectedPackageIds);
        const customerDisplay = this.getSharedOrderDisplay((order) => order.Customer);
        const destinationDisplay = this.getSharedOrderDisplay((order) => order.ShipToCompany || order.ShipToName);
        return (
            <React.Fragment>
            <WmsModel
                id={this.props.windowId + 'shipUcc128PackageLabelModel'}
                class='shipUcc128PackageLabelModel'
                title={this.translate('Label_Ucc128_Package_Labels')}
                width={760}
                height={multipleOrders ? 390 : (showPackagePicker ? 900 : 430)}
                onCloseFunc={this.props.onClose}
                isOpen={this.props.sharedIsOpenUcc128PackageLabelModel}
                keepTitleBarOnResize={true}
                customClass='wms-model-new-ui-wrapper'>
                <div className="model-content-wrapper">
                <WmsContainer>
                    {multipleOrders ? (
                        <div className="ucc128-multi-order-summary">
                            <div className="ucc128-orders-selected">
                                {this.translate('Label_Ucc128_Orders_Selected').replace('{count}', this.getSelectedOrders().length)}
                            </div>
                            <div className="ucc128-order-summary-row">
                                <span>{this.translate('FindOrders_Lbl_Customer')}</span>
                                <strong className={customerDisplay.multiple ? "is-multiple" : ""}>{customerDisplay.text}</strong>
                            </div>
                            <div className="ucc128-order-summary-row">
                                <span>{this.translate('Label_Ucc128_Destination')}</span>
                                <strong className={destinationDisplay.multiple ? "is-multiple" : ""}>{destinationDisplay.text}</strong>
                            </div>
                            <div className="ucc128-order-summary-row">
                                <span>{this.translate('Label_Packages')}</span>
                                <strong>{this.getPackageCount()}</strong>
                            </div>
                        </div>
                    ) : (
                    <div className="ucc128-order-summary">
                        <div className="ucc128-order-summary-column">
                            <div className="ucc128-order-summary-row">
                                <span>{this.translate('Label_Ucc128_Reference_Number')}</span>
                                <strong>{this.state.packReferenceNum != null ? this.state.packReferenceNum : this.getSharedOrderValue((order) => order.ReferenceNum)}</strong>
                            </div>
                            <div className="ucc128-order-summary-row">
                                <span>{this.translate('Label_Ucc128_Transaction_Number')}</span>
                                <strong>{this.getSharedOrderValue((order) => order.OrderId)}</strong>
                            </div>
                            <div className="ucc128-order-summary-row">
                                <span>{this.translate('Label_Ucc128_Po_Number')}</span>
                                <strong>{this.state.packPoNum != null ? this.state.packPoNum : this.getSharedOrderValue((order) => order.PoNum)}</strong>
                            </div>
                        </div>
                        <div className="ucc128-order-summary-column">
                            <div className="ucc128-order-summary-row">
                                <span>{this.translate('FindOrders_Lbl_Customer')}</span>
                                <strong>{this.getSharedOrderValue((order) => order.Customer)}</strong>
                            </div>
                            <div className="ucc128-order-summary-row">
                                <span>{this.translate('Label_Ucc128_Destination')}</span>
                                <strong>{this.getSharedOrderValue((order) => order.ShipToCompany || order.ShipToName)}</strong>
                            </div>
                            <div className="ucc128-order-summary-row">
                                <span>{this.translate('Label_Packages')}</span>
                                <strong>{this.getPackageCount()}</strong>
                            </div>
                        </div>
                    </div>
                    )}

                    <WmsDropdown
                        id="indexOptionsPackingReports"
                        name="indexOptionsPackingReports"
                        label={this.translate('Label_Ucc128_Package_Label_Template')}
                        wmsSelector={this.state.selector + "Ucc128PackageLabelReport"}
                        value={this.state.indexOptionsPackingReports}
                        onChangeFunc={this.handleChangeEvent}
                        options={this.state.optionsPackingReports}
                        textField='Name'
                        valueField='id'
                        extraWrapperClass="ucc128-template-dropdown"
                    />
                    <WmsDropdown
                        id="indexSelectedFormat"
                        name="indexSelectedFormat"
                        label={this.translate('Label_Ucc128_Package_Label_Format')}
                        wmsSelector={this.state.selector + "OutputType"}
                        value={this.state.indexSelectedFormat}
                        onChangeFunc={this.handleFormatChange}
                        options={this.state.optionsOutputTypes}
                        textField='Name'
                        valueField='Value'
                        extraWrapperClass="ucc128-format-dropdown"
                    />
                    {!multipleOrders && (
                    <label className="ucc128-package-selection-label">
                        {this.translate('Label_Ucc128_Print_Labels_For')}
                    </label>
                    )}
                    {!multipleOrders && (
                    <div className="ucc128-package-selection">
                    <WmsRadio
                        id="all"
                        name="packageSelection"
                        label={this.translate('Label_Ucc128_All_Packages')}
                        wmsSelector={this.state.selector + "Ucc128AllPackages"}
                        onChangeFunc={this.handlePackageSelectionChange}
                        checked={this.state.packageSelection === "all"}
                    />
                    <WmsRadio
                        id="selected"
                        name="packageSelection"
                        label={this.translate('Label_Ucc128_Selected_Packages')}
                        wmsSelector={this.state.selector + "Ucc128SelectedPackages"}
                        onChangeFunc={this.handlePackageSelectionChange}
                        checked={this.state.packageSelection === "selected"}
                    />
                    </div>
                    )}
                    {showPackagePicker && (
                        <WmsCollapse
                            id={this.props.windowId + "ucc128SelectPackages"}
                            headerLabel={this.translate('Label_Ucc128_Select_Packages')}
                            showCollapseIcon={false}
                            showCollapseText={false}
                        >
                        <div className="ucc128-package-picker">
                            <div className="ucc128-package-picker-toolbar">
                                <WmsCheckBox
                                    id={this.props.windowId + "ucc128SelectAll"}
                                    name="ucc128SelectAll"
                                    label={this.translate('Label_Ucc128_Select_All')}
                                    wmsSelector={this.state.selector + "Ucc128SelectAll"}
                                    checked={allPackagesSelected}
                                    disabled={packages.length === 0}
                                    onChangeFunc={this.onSelectAllChange}
                                    parentClassName="ucc128-select-all"
                                />
                                <div className="ucc128-package-search">
                                    <label className="ucc128-package-search-label" htmlFor={this.props.windowId + "ucc128SearchField"}>
                                        {this.translate('Label_Ucc128_Search_By')}
                                    </label>
                                    <div className="ucc128-package-search-controls">
                                        <select
                                            id={this.props.windowId + "ucc128SearchField"}
                                            ref={this.setSearchFieldRef}
                                            value={this.state.packageSearchField}
                                            onChange={() => {}}
                                            data-wms-selector={this.state.selector + "Ucc128SearchField"}
                                        >
                                            <option value="ucc128">{this.translate('Label_Ucc128_Barcode')}</option>
                                            <option value="packageId">{this.translate('Label_Ucc128_Package_Id')}</option>
                                        </select>
                                        <input
                                            type="text"
                                            ref={this.setSearchInputRef}
                                            value={this.state.packageSearchText}
                                            onChange={() => {}}
                                            placeholder={this.translate('Label_Ucc128_Search_Placeholder')}
                                            data-wms-selector={this.state.selector + "Ucc128PackageSearch"}
                                        />
                                        <span className="ucc128-package-search-icon" aria-hidden="true">
                                            <i className="fa fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className={"ucc128-package-grid " + this.props.windowId}>
                                {this.state.ucc128GridConfigReady && (
                                <VirtualGridComponent
                                    ref={(grid) => { this.packageWmsGrid = grid; }}
                                    id={this.packageGridId}
                                    gridName="ucc128PackageGrid"
                                    wmsSelector={this.state.selector + "Ucc128PackageGrid"}
                                    defaultColumns={this.packageGridColumns}
                                    allColumns={this.packageGridAllColumns}
                                    metaGridConfig={this.state.ucc128GridConfig}
                                    schema={this.packageGridSchema}
                                    staticGridData={this.state.optionsPackageUcc128}
                                    gridKeySelection="packageId"
                                    metaDataFieldsName="ucc128Packages"
                                    virtual={true}
                                    gridHeight="240px"
                                    totalResult={this.state.optionsPackageUcc128.length}
                                    shawCheckbox={false}
                                    showResetButton={false}
                                    showGridSummary={true}
                                    showGridResult={false}
                                    summaryMenuIcon="ellipsis"
                                    onSummaryMenuClick={this.openPackageColumnChooser}
                                    showSortColumns={false}
                                    filterText=""
                                    menu={[]}
                                    emptyRecoredText={this.translate('Label_Ucc128_No_Packages')}
                                    onSelection={this.onPackageGridSelection}
                                    onDataBound={this.onPackageGridDataBound}
                                    clickEventOfContextMenu={() => {}}
                                />
                                )}
                            </div>
                        </div>
                        </WmsCollapse>
                    )}
                </WmsContainer>

                </div>
                <div className="footer-btn-holder">
                    <WmsButton
                        label={this.translate("Label_Cancel")}
                        wmsSelector={this.state.selector + "Ucc128PackageLabelExit"}
                        onClickFunc={this.props.onClose}
                        buttonType='yellow'
                        icon={'fa-ban'}
                    />
                    <WmsButton
                        label={multipleOrders ? this.translate('Label_Ucc128_Print_All') : this.translate('Label_Print')}
                        wmsSelector={this.state.selector + "GenerateUcc128PackageLabel"}
                        id={"generateSlip"+this.props.windowId}
                        onClickFunc={this.generatePapiUcc128PackageLabel}
                        disabled={this.state.gifUcc128PackageLabel
                            || !this.state.indexOptionsPackingReports
                            || (showPackagePicker && this.state.selectedPackageIds.length === 0)}
                        loading={this.state.gifUcc128PackageLabel}
                        icon={'fa-check-square-o'}
                    />

                </div>


            </WmsModel>
            {this.state.isOpenPackageColumnChooser && (
                <AddEditColumnModel
                    id={this.props.windowId + "ucc128PackageColumns"}
                    height={360}
                    windowId={this.props.windowId}
                    gridId={this.packageGridId}
                    allSortColumnList={this.packageGridAllColumns}
                    isAnotherModelOpen={true}
                    onCloseColumnModel={this.closePackageColumnChooser}
                    isOpenColumnModel={this.state.isOpenPackageColumnChooser}
                    updateGridData={this.updatePackageGridData}
                    saveChangesInMetaData={this.savePackageColumnLayout}
                />
            )}
            </React.Fragment>
        )
    }
}
